import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import AuthComponent from "../../../common/AuthComponent";
import Page from "../../../page";
import SolutionHeader from "../../SolutionHeader/SolutionHeader";
import { setScreen } from '../../../../redux/connectedComponent/uiFactory/uiFactory.slice';
import { screens } from '../../../config/uiFactory.config';
import './styles/appConsents.scss';
import JSZip from 'jszip';
import JSZipUtils from 'jszip-utils';
import { IconButton,
  IconFileDownload,
  SimpleTable,
  SimpleTableBody,
  SimpleTableToolbar,
  SimpleTableContainer,
  SimpleTableHead,
  SimpleTableHeader,
  SimpleTableRow,
  SimpleTableData,
  SimpleTableWrapper, Loader} from 'cdk-radial';
import { getConsents, getSignedS3Consents, updateSignedConsentDetails } from '../../../../redux/connectedComponent/consentDetails/consentDetails.slice';
import styled from 'styled-components';
import { saveAs } from 'file-saver';
import moment from "moment";
import { sendAmplitudeData } from  '../../../../utils/amplitude';
import { AMPLITUDE_EVENTS, AMPLITUDE_PROPERTIES } from '../../../../constants/amplitudeConstants';
import { trackPageView } from '../../../../utils/gtm';

const COLOR_STROKE = '#006CFA';

const ZebraSimpleTableRow = styled(SimpleTableRow)`
  :nth-child(even) {
    background-color: #F8F8F8;
    border-top: 1px solid #dcddde;
  }
  &:last-child {
    border-bottom: none;
  }
`;

const UNDEFINED = 'undefined undefined';

function AppConsents ({ solutionData = {}, additionalData = {} }) {

  const { id = '' } = solutionData;

  const { subscriptionData } = additionalData;

  const entityList = subscriptionData.map(item => {
      return {
        entityId: item.entityId,
        location: item.entityIdList?.[0]?.location,
        date: item.subscribedOn
      };
  })

  const state = useSelector(state => state);

  const dispatch = useDispatch();

  const token = state.loginDetailsSlice.authenticationToken;
  const entityIdNameMapping = state.loginDetailsSlice.entityIdNameMapping;
  const entityIdAddressMapping = state.loginDetailsSlice.entityIdAddressMapping;
  const consentDetails = state.consentDetailsSlice.consentDetails;
  const signedConsentDetails = state.consentDetailsSlice.signedConsentDetails;
  const pendingLocations = state.consentDetailsSlice.signedUrlPendingLocations;
  const [tableData, setTableData] = useState([]);

  const dataRightsEnabled = (solutionData && solutionData.data_rights && solutionData.data_rights.captureDataRightsConsent) || false;

  useEffect(() => {
    trackPageView('App Documents');
    entityList && entityList.length && entityList.forEach(item => {
      const entityId = item.entityId;
      dispatch(getConsents({ id, entityId, token }));
      if (dataRightsEnabled) {
        dispatch(getConsents({ id: `dataRights-${entityId}`, entityId, token }));
      }
    });
  }, []);

  useEffect(() => {
    if (consentDetails && Object.keys(consentDetails).length === entityList.length) {
      for (var key in consentDetails) {
        dispatch(updateSignedConsentDetails({ entityId: key, signBy: consentDetails[key].signBy }));
        const documents = consentDetails[key].documents;
        const entityId = key;
        documents && documents.forEach(document => {
          if (document.appTerms) {
            const appTerms = document.appTerms;
            const consentUrl = appTerms.split('.com/');
            appTerms && dispatch(getSignedS3Consents({ type: 'appTerms', expires: 3600, fileName: consentUrl && consentUrl[1], token, entityId }));
          } else if (document.customConsent) {
            const customConsent = document.customConsent;
            const consentUrl = customConsent.split('.com/');
            customConsent && dispatch(getSignedS3Consents({ type: 'customConsentForm', expires: 3600, fileName: consentUrl && consentUrl[1], token, entityId }));
          } else if (document.signedTerms) {
            const signedTerms = document.signedTerms;
            const consentUrl = signedTerms.split('.com/');
            signedTerms && dispatch(getSignedS3Consents({ type: 'signedTerms', expires: 3600, fileName: consentUrl && consentUrl[1], token, entityId }));
          } else if (document.payments) {
            const paymentsUrl = document.payments;
            const consentUrl = paymentsUrl && paymentsUrl.slice(paymentsUrl.indexOf('MonetisationServiceAgreement'));
            paymentsUrl && dispatch(getSignedS3Consents({ type: 'monetizationAgreement', expires: 3600, fileName: consentUrl, token, entityId }));
          } else if (document.dataRights) {
            let fileName = document.dataRights.split('.com/')[1]
            fileName && dispatch(getSignedS3Consents({ type: 'dataRights', expires: 3600, fileName , token, entityId }));
          } else if (document.apiTerms) {
            dispatch(updateSignedConsentDetails({ entityId, document: document.apiTerms }));
          }
        });
      }
    }
  }, [consentDetails]);

  useEffect(() => {
    if (signedConsentDetails) {
      const data = [];
      for (var key in signedConsentDetails){
        const entityId = key;
        const location = entityIdNameMapping[entityId];
        const address = entityIdAddressMapping[entityId];
        let signedBy = '';
        let role = ''
        let subscribedOn = '';
        let documents = [];
        let signBy = signedConsentDetails[key].signBy;
        let businessRoles = signedConsentDetails[key].businessRoles
        if (signBy.length > 1) {
          signBy.forEach(item => {
            if (signedBy) {
              signedBy = `${signedBy}\n${item}`;
            } else {
              signedBy = item;
            }
          });
        } else if (signBy.length === 1) {
          signedBy = signBy[0];
        }
        if (businessRoles.length > 1) {
          businessRoles.forEach(item => {
            if (role) {
              role = `${role}\n${item}`;
            } else {
              role = item;
            }
          });
        } else if (businessRoles.length === 1) {
          role = businessRoles[0];
        }
        documents = signedConsentDetails[key].documents;
        const subscriptionDetails = entityList.filter(item => item.entityId === entityId);
        subscribedOn = subscriptionDetails.length ? moment(subscriptionDetails[0].date).format('MM/DD/YYYY HH:mm:ss'): '';
        data.push({
          location,
          address,
          signedBy: <span className="line-break">{signedBy === UNDEFINED || !signedBy ? 'NA' : signedBy}</span>,
          businessRoles: <span className="line-break">{role ? role : 'NA'}</span>,
          subscribedOn: subscribedOn,
          action: downloadButton(documents, location),
        });
      }
      setTableData(data);
    }
  },[signedConsentDetails]);

  const downloadButton = (documents, location) => {
    return !documents?.length ? 'N/A' : (
      <IconButton
        label={location}
        icon={<IconFileDownload />}
        onClick={function() {
          onDownloadClick(documents, location);
        }}
        text={'action'}
      />
    );
  }

  const onDownloadClick = (documents, location) => {
    sendAmplitudeData(AMPLITUDE_EVENTS.APP_DOCUMENT_DOWNLOAD, {
      [AMPLITUDE_PROPERTIES.APP_NAME]: solutionData?.overview?.name,
      [AMPLITUDE_PROPERTIES.APP_ID]: solutionData?.id,
      [AMPLITUDE_PROPERTIES.ORG_NAME]: location
    });

    var zip = new JSZip();
    var count = 0;
    var zipFilename = `${location}.zip`;
    documents.forEach(function (document) {
      var filename = document.substring(document.lastIndexOf("/") + 1).trim();
      filename = filename.split('%20').join(' ');
      if (filename.includes('?')) {
        const name = filename.split('?');
        filename = name[0];
      }
      console.log('downloading:', document);
      JSZipUtils.getBinaryContent(document, function (err, data) {
        if (err) {
          throw err;
        }
        zip.file(filename, data, {
          binary: true
        });
        count++;
        if (count === documents.length) {
          zip.generateAsync({
            type: "blob"
          })
            .then(function (blob) {
              saveAs(blob, zipFilename);
            });
        }
      });
    });
  }

  const onBackButtonClickHandler = () => {
      dispatch(setScreen({screen: screens.SUBSCRIPTION_MANAGEMENT}));
  };

  const isLoading = tableData.length !== entityList.length || !!pendingLocations.length;

  return (
    <Page>
      <SolutionHeader
        solutionData={solutionData}
        onBackButtonClickHandler={onBackButtonClickHandler}
      />
      <div className="app-consents">
        <div className={'app-consents__header'}>
          <FormattedMessage
            id="Solution.Header"
            defaultMessage={'App Documents'}
          />
        </div>
        <div className={'app-consents__description'}>
          <FormattedMessage
            id="Solution.Description"
            defaultMessage={
              'See at a glance who authorized the app per location and access the documents to review or download.'
            }
          />
        </div>
        <div className="consent-table">
          <SimpleTableWrapper>
            <SimpleTableToolbar style={{minHeight:'0px'}}></SimpleTableToolbar>
            <SimpleTableContainer>
              <SimpleTable aria-label="Table">
                <SimpleTableHead className='table-header'>
                  <SimpleTableRow>
                    <SimpleTableHeader className='location-column'>Location</SimpleTableHeader>
                    <SimpleTableHeader className='address-column'>Address</SimpleTableHeader>
                    <SimpleTableHeader className='signed-by-column'>
                      Signed By
                    </SimpleTableHeader>
                    <SimpleTableHeader className='signed-by-column'>
                      Business Title
                    </SimpleTableHeader>
                    <SimpleTableHeader className='subscribed-on-column'>
                      {solutionData.activateOnly === false ? 'Subscribed On' : 'Activated On'}
                    </SimpleTableHeader>
                    <SimpleTableHeader className='documents-column'>
                      Documents (PDF)
                    </SimpleTableHeader>
                  </SimpleTableRow>
                </SimpleTableHead>
                {
                  !isLoading &&
                    <SimpleTableBody className='table-body'>
                      {tableData.map((row, index) => (
                        <ZebraSimpleTableRow key={index} className='table-row'>
                          <SimpleTableData className='location-column'>{row.location}</SimpleTableData>
                          <SimpleTableData className='address-column'>{row.address}</SimpleTableData>
                          <SimpleTableData className='signed-by-column'>{row.signedBy}</SimpleTableData>
                          <SimpleTableData className='signed-by-column'>{row.businessRoles}</SimpleTableData>
                          <SimpleTableData className='subscribed-on-column'>{row.subscribedOn}</SimpleTableData>
                          <SimpleTableData className='documents-column'>{row.action}</SimpleTableData>
                        </ZebraSimpleTableRow>
                      ))}
                    </SimpleTableBody>
                }
              </SimpleTable>
            </SimpleTableContainer>
          </SimpleTableWrapper>
        </div>
        {
          isLoading &&
            <div className='consent-table-loader'>
              <Loader  style={{ stroke: COLOR_STROKE }} label={'Fetching Consent Details'}/>
            </div>
        }
      </div>
    </Page>
  );
}
export default AuthComponent(AppConsents);
